"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenesysAgentCallbackType = void 0;
var GenesysAgentCallbackType;
(function (GenesysAgentCallbackType) {
    GenesysAgentCallbackType["LESA"] = "LESA";
    GenesysAgentCallbackType["HOTELS_AND_VILLAS"] = "HOTELS_AND_VILLAS";
    GenesysAgentCallbackType["TOURS"] = "TOURS";
    GenesysAgentCallbackType["SUPPORT"] = "SUPPORT";
    GenesysAgentCallbackType["SALES"] = "SALES";
})(GenesysAgentCallbackType || (exports.GenesysAgentCallbackType = GenesysAgentCallbackType = {}));
